import { render, staticRenderFns } from "./DeclineView.vue?vue&type=template&id=453cc54e&scoped=true&"
import script from "./DeclineView.vue?vue&type=script&lang=js&"
export * from "./DeclineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453cc54e",
  null
  
)

export default component.exports